import React from 'react'
import Politics from '../sections/Politics/Politics'

const PolDePriv = () => {
    return (
        <Politics/>
    )
}

export default PolDePriv